<div class="language-switcher">
    <button mat-button [matMenuTriggerFor]="menu" class="language-button">
        <img [src]="currentFlag()" alt="Flag" class="flag-icon" />
        <span class="language-label">{{ currentLang().toUpperCase() }}</span>
    </button>
    <mat-menu #menu="matMenu">
        <button *ngFor="let lang of languages" mat-menu-item (click)="changeLanguage(lang.code)" class="language-item">
            <div class="menu-content">
                <img [src]="lang.flag" alt="{{ lang.code }}" class="flag-icon" />
                <span class="language-label">{{ lang.label }}</span>
            </div>
        </button>
    </mat-menu>
</div>